export default __webpack_public_path__ + "static/media/mechanism-capital@2x.767a67b0.png";